<script>
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import passportsStore from "../stores/passportsStore";
    import Alert from "../stores/alerts";
    import {formatDate, passportStatus} from "../lib/lib";
    import {PASSPORT_STATUS} from "../lib/constants";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import Pagination from "../components/Pagination.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import PassportCreateModal from "./PassportCreateModal.svelte";
    import PassportModal from "./PassportModal.svelte";
    import PassportNumberControl from "../components/controls/PassportNumberControl.svelte";
    import OrderModal from "../orders/OrderModal.svelte";
    import PassportsDestroyModal from "./PassportsDestroyModal.svelte";


    let list = null;
    let total = 0;
    let page = 1;
    let search = {
        limit: 50,
        offset: 0,
        date_from: '',
        date_to: '',
        passport_number: '',
        ref_id: '',
        member: '',
        view: '1',
        sort_field: 'passport_from',
        sort_way: 'DESC'
    }
    let selectedId = null;
    let editId = null;
    let editOrderId = null;

    let showPassportsDestroy = false;

    const pageHeaderControls = [
        {id: 'create', name: 'ΠΡΟΣΘΗΚΗ ΔΙΑΒΑΤΗΡΙΩΝ'},
        {id: 'destroy', name: 'ΚΑΤΑΣΤΡΟΦH ΔΙΑΒΑΤΗΡΙΩΝ'},
        // {id: 'export', name: 'Εξαγωγή', icon: 'file-excel'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'passport_from', title: 'ΑΡΙΘΜΟΣ', sortable: true, sort_way: 'DESC'},
        {key: 'total', title: 'ΣΥΝ.', sortable: true},
        {key: 'member', title: 'ΜΕΛΟΣ'},
        {key: 'afm', title: 'Α.Φ.Μ.'},
        {key: 'status', title: 'ΚΑΤΑΣΤΑΣΗ', sortable: true},
        {key: 'synced_at', title: 'ΣΥΓΧΡ.', sortable: true},
        {key: 'ref_id', title: 'ΠΑΡΑΓΓΕΛΙΑ'},
        {key: '', title: ''},
    ];

    const itemsPerPage = [20, 50, 100, 500];

    const initialize = () => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const ref_id = urlParams.get('order')
        if (ref_id) {
            search.view = '';
            search.ref_id = ref_id;
        }

        load(LOADER.PAGE);
    }

    const load = (loader = LOADER.POPUP) => {
        const onSuccess = result => {
            list = result.list;
            total = result.total;
            list.map(item => {
                item.synced_at = formatDate(item.synced_at, 'd-m-y H:m');
                item.status_str = passportStatus(item.status);
            });
            $app.passports_for_sync = result.passports_for_sync;
        }

        const onFailure = err => {
        };

        search.offset = (page - 1) * search.limit;

        R.handle(R.passport.index, search, onSuccess, onFailure, loader);
    }

    const onSearch = () => {
        page = 1;
        load();
    }

    const clearSearch = () => {
        search.date_from = '';
        search.date_to = '';
        search.view = '';
        search.ref_id = '';
        search.member = '';
        search.passport_number = '';
        page = 1;
        load();
    }

    const onColumnSort = ({detail}) => {
        search.sort_field = detail.key;
        search.sort_way = detail.sort_way;
        load();
    }

    const onPageChange = ({detail}) => {
        page = detail;
        load();
    }

    const onCreate = () => {
        editId = 0;
    }

    const closeCreate = param => {
        editId = null;
        if (param) {
            selectedId = param.id;
            passportsStore.setRequest(param, syncCallBack);
        }
    }

    const onEdit = item => {
        selectedId = item.id;
        editId = item.id;
    }

    const closeEdit = () => {
        editId = null;
    }

    const onDestroy = () => {
        showPassportsDestroy = true;
    }

    const closeDestroy = () => {
        showPassportsDestroy = false;
    }

    const syncCallBack = (param) => {
        if (param) {
            let item = list.find(x => x.id === param.id);
            if (item) {
                item.status = param.status;
                item.status_str = passportStatus(param.status);
                item.synced_at = formatDate(param.synced_at, 'd-m-y H:m');
                item.error = param.error;
            }
            list = list;
        }
    }

    const onOpenOrder = order_id => {
        editOrderId = order_id;
    }

    const closeOrder = param => {
        editOrderId = null;
        if (param) {
            load();
        }
    }

    // const onExport = () => {
    //
    //     const onSuccess = result => {
    //         Alert.alert("Εξαγωγή διαβατηρίων", `Η εξαγωγή ολοκληρώθηκε.\nΑρχείο εξαγωγής:\n<a href="${result.link}" target="_blank">${result.link}</a>`);
    //     }
    //
    //     const onFailure = err => {
    //     };
    //
    //     if (!list || list.length == 0) {
    //         Alert.warning("Εξαγωγή διαβατηρίων", "Δεν βρέθηκαν διαβατήρια για εξαγωγή!");
    //         return;
    //     }
    //
    //     R.handle(R.passport.export, search, onSuccess, onFailure, LOADER.POPUP);
    // }

    initialize();

    $: {
        if ($passportsStore.changed) {
            $passportsStore.changed = false;
            load();
        }
    }
</script>

<!--<PageHeader title="Διαβατήρια" controls={ pageHeaderControls } on:create={ onCreate } on:export={ onExport }-->
<!--            on:reload={ load }/>-->
<PageHeader title="Διαβατήρια" controls={ pageHeaderControls } on:create={ onCreate } on:destroy={onDestroy}
            on:reload={ load }/>

<div class="panel panel-simple pb-2 mb-5">
    <div class="row row-condensed">
        <div class="column-condensed col-xl-1 col-lg-2 col-md-3 col-6 pt-2">
            <div class="form-item">
                <div class="form-item-info top">αποστολή από</div>
                <input type="date" class="form-control" bind:value={ search.date_from } on:change={ onSearch }>
            </div>
        </div>
        <div class="column-condensed col-xl-1 col-lg-2 col-md-3 col-6 pt-2">
            <div class="form-item">
                <div class="form-item-info top">έως</div>
                <input type="date" class="form-control" bind:value={ search.date_to } on:change={ onSearch }>
            </div>
        </div>
        <div class="column-condensed col-xl-2 col-lg-4 col-md-3 col-6 pt-2">
            <select class="form-select" bind:value="{ search.view }" on:change={ onSearch }>
                <option value="">κατάσταση</option>
                <option value="1">Προς αποστολή</option>
                <option value="2">Ανατεθειμένα</option>
                <option value="3">Επιστροφές</option>
                <option value="4">Κατεστραμμένα</option>
            </select>
        </div>
        <div class="column-condensed col-xl-2 col-lg-4 col-md-3 col-6 pt-2">
            <PassportNumberControl bind:value="{ search.passport_number }" on:change={ onSearch }
                                   placeholder="αρ. διαβατηρίου"/>
        </div>
        <div class="column-condensed col-xl-2 col-lg-4 col-md-3 col-6 pt-2">
            <input type="text" class="form-control" bind:value={ search.ref_id } on:change={ onSearch }
                   placeholder="αρ. παραγγελίας">
        </div>
        <div class="column-condensed col-xl-2 col-lg-4 col-md-3 col-6 pt-2">
            <input type="text" class="form-control" bind:value={ search.member } on:change={ onSearch }
                   placeholder="όνομα ή Α.Φ.Μ. μέλους">
        </div>
        <div class="column-condensed col-xl-1 col-lg-2 col-md-2 col-6 pt-2">
            <button class="btn btn-default btn-block" on:click={ clearSearch }>ΚΑΘΑΡΙΣΜΟΣ</button>
        </div>
        <div class="column-condensed col-xl-1 col-lg-2 col-md-2 col-6 pt-2">
            <button class="btn btn-outline btn-block" on:click={ onSearch }>ΕΥΡΕΣΗ</button>
        </div>
    </div>
</div>

<div class="row align-items-center mb-4">
    <div class="col-xl-2 col-lg-3 col-md-4">
        <select class="form-select form-select-sm" bind:value="{ search.limit }" on:change="{ onSearch }">
            {#each itemsPerPage as item}
                <option value="{ item }">εμφάνιση { item } / σελίδα</option>
            {/each}
        </select>
    </div>
    <div class="col-xl-10 col-lg-9 col-md-8 hidden-xs">
        <div class="color-tips d-flex align-items-center">
            <div class="color-tip d-flex align-items-center me-3">
                <div class="color status-0"></div>
                Ανάθεση
            </div>
            <div class="color-tip d-flex align-items-center me-3">
                <div class="color status-1"></div>
                Επιστροφή
            </div>
            <div class="color-tip d-flex align-items-center me-3">
                <div class="color status-2"></div>
                Καταστροφή
            </div>
        </div>
    </div>
</div>

{#if list}
    {#if list.length}
        <table class="table table-list mb-4">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>
            {#each list as item}
                <tr class="row-hover" class:row-selected={ selectedId === item.id }>
                    <td class="passports-column">
                        <div class="status status-{ item.status}"></div>
                        <span class="is-link"
                              class:not-active={ item.status == PASSPORT_STATUS.RETURNED || item.status == PASSPORT_STATUS.DESTROYED }
                              on:click={ () => onEdit(item) }>
                            { $passportsStore.prefix }{ item.passport_from }
                            - { $passportsStore.prefix }{ item.passport_to }
                        </span>
                    </td>
                    <td class="total-column text-gray text-center">{ item.total }</td>
                    <td class="text-gray">{ item.member?.lastname || '' } { item.member?.firstname || '' }</td>
                    <td class="text-gray">{ item.member?.afm || '' }</td>
                    <td class="text-gray">{ item.status_str }</td>
                    <td class="datetime-column text-gray">{ item.synced_at }</td>
                    <td class="ref-id-column text-gray">
                        {#if item.order}
                            <span class="is-link" on:click={ () => onOpenOrder(item.order.id) }>
                                { item.order.ref_id }
                            </span>
                        {/if}
                    </td>
                    {#if item.status < 0}
                        <td class="button-column pointer" on:click="{ () => onEdit(item) }">
                            <AppIcon icon="upload" size="16"/>
                        </td>
                    {:else}
                        <td></td>
                    {/if}
                </tr>
            {/each}
            </tbody>
        </table>
        <Pagination itemsPerPage="{ search.limit }" totalItems="{ total }" { page } on:change="{ onPageChange }"/>
    {:else}
        <div class="panel-simple panel-pad">
            Δεν βρέθηκαν διαβατήρια.
        </div>
    {/if}
{/if}

{#if editId != null}
    {#if editId == 0}
        <PassportCreateModal closeCallback="{ closeCreate }"/>
    {:else}
        <PassportModal passportId="{ editId }" closeCallback="{ closeEdit }"/>
    {/if}
{/if}

{#if editOrderId}
    <OrderModal orderId="{ editOrderId }" closeCallback="{ closeOrder }"/>
{/if}

{#if showPassportsDestroy}
    <PassportsDestroyModal closeCallback={ closeDestroy }/>
    /
{/if}

<style>
    .passports-column {
        position: relative;
        width: 220px;
    }

    .total-column {
        width: 50px;
    }

    .ref-id-column {
        width: 120px;
    }

    .status {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 5px;
        background-color: #efefef;
    }

    .row-condensed {
        margin-left: 5px;
        margin-right: 5px;
    }

    .row-condensed .column-condensed {
        padding-left: 5px;
        padding-right: 5px;
    }

    /* assign */
    .status-0, .status--1 {
        border-right: 1px solid #efefef;
        background-color: #fff;
    }

    /* cancel */
    .status-1, .status--2 {
        /*background-color: #03a9f4;*/
        background-color: #3f51b5;
    }

    /* destroy */
    .status-2, .status--3 {
        /*background-color: #ffc107;*/
        background-color: #f44336;

    }

    /* completed */
    .status-4 {
        background-color: #ff9800;
    }

    /* returned */
    .status-5 {
        background-color: #3f51b5;
    }

    /* canceled, failed */
    .status-6, .status-7 {
        background-color: #f44336;
    }

    .color-tips .color-tip {
        line-height: 1;
    }

    .color-tips .color-tip .color {
        width: 12px;
        height: 12px;
        border: 1px solid #efefef;
        /*background: #ccc;*/
        margin-right: 5px;
    }
</style>
